import React, { useState, useEffect } from 'react';
import Popup from '../../index';
import {recordingConfirmPopupDisplay} from '../../../../../actions/popupActions';
import {findContacts} from '../../../../../actions/contactActions';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from "react-i18next";
import {findContactDetails} from '../../../../../actions/contactDetailsActions';
import './index.css';

export default function RecordingConfirmPopup({mode}) {
	const [countdown, setCountdown] = useState(10);
	const [showClose, setShowClose] = useState(false);

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const contactsPageSize = useSelector(state => state.contactReducer.contactsPageSize);
	const contactDetails = useSelector(state => state.contactDetailsReducer.findContactDetails);

	const dispatch = useDispatch();

	const { t } = useTranslation();

	useEffect(() => {
		if (countdown > 0) {
			const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
			return () => clearTimeout(timer);
		} else if (countdown === 0 && !showClose) {

			if(mode === 'create'){
				dispatch(findContacts(selectedContactsGroup ? selectedContactsGroup.id : '6', contactsPageSize));
			} else {
				dispatch(findContactDetails(contactDetails.id, contactDetails.phoneContactEntry.type));
			}

			setShowClose(true);

		}
	}, [dispatch, selectedContactsGroup, mode, contactDetails, contactsPageSize, countdown, showClose]);

	const handleClose = () => {
		dispatch(recordingConfirmPopupDisplay(null));
	};

	const progress = ((10 - countdown) / 10) * 100;

	return (
		<Popup unClosable={!showClose} className="p-4 sm-popup" onClick={ handleClose }>
			<div className={`gauge${!showClose ? ' in-progress' : ''}`}>

				<svg width="100" height="100" viewBox="0 0 100 100" className="position-relative" style={{ zIndex: 2 }}>
					<circle cx="50" cy="50" r="45" fill="none" stroke="#e9ecef" strokeWidth="4" />
					<circle
						cx="50"
						cy="50"
						r="45"
						fill="none"
						stroke="url(#gradient)"
						strokeWidth="4"
						strokeLinecap="round"
						strokeDasharray={`${2 * Math.PI * 45}`}
						strokeDashoffset={2 * Math.PI * 45 * (1 - progress / 100)}
						transform="rotate(-90 50 50)"
						style={{ transition: 'stroke-dashoffset 0.5s ease-in-out' }}
					/>
					<defs>
						<linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
							<stop offset="0%" stopColor="#007bff" />
							<stop offset="100%" stopColor="#6f42c1" />
						</linearGradient>
					</defs>
				</svg>

				<div className="position-absolute" style={{ zIndex: 3 }}>
					<div className={!showClose ? 'swing' : ''} style={{ fontSize: '2.5rem', color: '#007bff' }}>
						👤
					</div>
				</div>
				<div className="position-absolute" style={{width:100, height:100}}>
					{ !showClose &&
					[...Array(6)].map((_, i) => (
						<div
							key={i}
							className="position-absolute sparkle"
							style={{
								left: `${36 + 66 * Math.cos((i * Math.PI * 2) / 6)}px`,
								top: `${33 + 66 * Math.sin((i * Math.PI * 2) / 6)}px`,
								animationDelay: `${i * 0.2}s`,
							}}
						>
							<span style={{ color: '#ffc107', fontSize: '1.5rem' }}>✨</span>
						</div>
					))
					}
				</div>
			</div>

			<div className="text-center">
				{
					mode === 'create'
					?
						<>
							<h5 className={`text-dark mb-3 ${!showClose ? 'pulse-text' : ''}`}>
								{
									showClose
									?
										t('recordingConfirmPopupContactCreationTitle')
									:
										t('recordingConfirmPopupContactCreationPending')
								}
							</h5>
							{!showClose ? (
								<div className="text-muted fade-in">
									⚡ {t('recordingConfirmPopupContactCreationInProgress')} {countdown}s
								</div>
							) : (
								<p className="text-muted fade-in-up">
									{t('recordingConfirmPopupContactAdded')}
								</p>
							)}
						</>
					:
						<>
							<h5 className={`text-dark mb-3 ${!showClose ? 'pulse-text' : ''}`}>
								{
									showClose
									?
										t('recordingConfirmPopupContactUpdateTitle')
									:
										t('recordingConfirmPopupContactUpdatePending')
								}
							</h5>
							{!showClose ? (
								<div className="text-muted fade-in">
									⚡ {t('recordingConfirmPopupContactUpdateInProgress')} {countdown}s
								</div>
							) : (
								<p className="text-muted fade-in-up">
									{t('recordingConfirmPopupContactUpdated')}
								</p>
							)}
						</>
				}
				{showClose && (
					<button
						className="btn btn-danger mt-2 fade-in-up"
						onClick={ handleClose }
					>
						{t('closeBtn')}
					</button>
				)}
			</div>
		</Popup>
	);
}
